"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pickSome = exports.randomUpToNExcl = exports.pickNPseudoRandomly = void 0;
const pickNPseudoRandomly = (n) => (origArr, alreadyTakenArr = []) => {
    const remainingItems = origArr.length - alreadyTakenArr.length;
    if (n > origArr.length) {
        throw new Error([
            `pickN: you want to pick more items than the original array has.`,
            `n ${n}, origArr.len ${origArr.length}, already taken len ${alreadyTakenArr.length}, remaining items ${remainingItems}`,
        ].join("\n"));
    }
    if (n > remainingItems) {
        return [];
    }
    if (n === remainingItems) {
        return origArr.filter((item) => !alreadyTakenArr.includes(item));
    }
    const selectedItems = new Set();
    let tempN = n;
    const maxIdx = origArr.length - 1;
    const maxFailureTries = 20;
    let availableFailureTries = maxFailureTries;
    while (tempN > 0) {
        if (availableFailureTries <= 0) {
            console.warn("available failure tries reached 0, tempN =", tempN, "remaining items:", origArr.filter((item) => !alreadyTakenArr.includes(item)));
            break;
        }
        const toInt = Math.random() <= 0.5 ? Math.floor : Math.ceil;
        const candidateIdx = toInt(Math.random() * maxIdx);
        const candidate = origArr[candidateIdx];
        if (selectedItems.has(candidate) || alreadyTakenArr.includes(candidate)) {
            availableFailureTries--;
            continue;
        }
        else {
            selectedItems.add(candidate);
            tempN--;
            availableFailureTries = maxFailureTries;
        }
    }
    const arr = [...selectedItems.values()];
    return arr;
};
exports.pickNPseudoRandomly = pickNPseudoRandomly;
const randomUpToNExcl = (n) => Math.ceil(Math.random() * (n - 1));
exports.randomUpToNExcl = randomUpToNExcl;
const pickSome = (origArr, { maxCount = origArr.length, alreadyTakenArr = [], }) => {
    maxCount = Math.min(maxCount, origArr.length);
    const howManyToPick = exports.randomUpToNExcl(maxCount);
    return exports.pickNPseudoRandomly(howManyToPick)(origArr, alreadyTakenArr);
};
exports.pickSome = pickSome;
//# sourceMappingURL=random.js.map